<template>
	<div v-if="form" :id="$vnode.key" class="c-block-list-form-custom">
		<TransitionExt
			name="block-list-form-custom"
			duration="200"
			mode="out-in"
		>
			<UmbracoForm
				:id="form"
				ref="form"
				class="s-umbraco-form bg-background px-3xl py-2xl"
				:definitions-endpoint="definitionsUrl"
				:post-endpoint="entriesUrl"
			>
				<template #loading>
					<div
						class="w-full flex flex-col justify-center items-center"
						style="height: min(80vh, 600px)"
					>
						<LoaderGraphic class="w-full h-full" />
					</div>
				</template>

				<template #error="{ error }">
					<BaseH2 class="mb-sm"> Der skete en fejl </BaseH2>
					Fejlbesked: "{{ error.message }}"

					<BaseButton class="mt-md" @click="tryAgain">
						Prøv igen
					</BaseButton>
				</template>

				<template #title="{}">
					<span></span>
				</template>
			</UmbracoForm>
		</TransitionExt>
	</div>
</template>

<script>
import UmbracoForm from '~/citi-baseline/components/UmbracoForm';
import LoaderGraphic from '~/components/shared/LoaderGraphic';

export default {
	name: 'BlockListFormCustom',

	components: {
		UmbracoForm,
		LoaderGraphic,
	},

	inheritAttrs: false,

	props: {
		renderUrl: String,
		definitionsUrl: String,
		entriesUrl: String,
		form: String,
	},

	methods: {
		tryAgain() {
			this.$refs.form?.fetchFormMarkup?.();
		},
	},
};
</script>

<style lang="postcss">
.c-block-list-form-custom {
	contain: paint;
}

.t-block-list-form-custom-enter-active,
.t-block-list-form-custom-leave-active {
	@apply transition-opacity ease-smooth-out;
}
.t-block-list-form-custom-enter,
.t-block-list-form-custom-leave-to {
	@apply opacity-0;
}
</style>
